<template>
    <v-card>
        <v-card-title class="text-h5 bg-grey-lighten-2" primary-title>
            Configure Samples & Request
            <v-spacer></v-spacer>
        </v-card-title>
        <v-card-text>
            <MaterialSamplesForm
                ref="samplesChildForm"
                :experiment="experiment"
                :things="things"
                :sops="sops"
                :embedded="true"
                v-model="materialSamplesContext"
                v-model:valid="materialSamplesValid"
            />
            <RequestForm
                ref="requestChildForm"
                class="mt-4"
                :protocols="requestProtocols"
                :embedded="true"
                v-model="request"
                v-model:valid="requestValid"
            />
        </v-card-text>
        <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn @click="cancel" color="primary">Cancel</v-btn>
            <v-btn @click="configure" color="primary" :disabled="!isAllValid">Configure</v-btn>
        </v-card-actions>
    </v-card>
</template>

<script setup lang="ts">
import { computed, ref } from "vue";
import { Experiment } from "@/services/things/models";
import {
  Request,
  SavedMaterialSampleSOP,
  MaterialSamplesContext,
  SavedMaterialSampleSet,
  SavedRequestProtocol,
  RequestStatus,
} from "@/services/samples/samplesAPI";
import MaterialSamplesForm from "./MaterialSamplesForm.vue";
import RequestForm from "./RequestForm.vue";
import { withLoadingScreen } from "@/lib/loading";

const props = defineProps<{
    experiment: Experiment;
    things: Array<{
        id: string;
        name: string;
    }>;
    sops: SavedMaterialSampleSOP[];
    requestProtocols: SavedRequestProtocol[];
}>();

interface RequestFormInstance {
    saveRequest: () => Promise<Request>;
}

interface MaterialSamplesFormInstance {
    saveSampleSet: () => Promise<SavedMaterialSampleSet>;
}

const emit = defineEmits<{
    (e: "canceled"): void;
    (e: "configureSamples", payload: MaterialSamplesContext): void;
    (e: "configureRequest", payload: Request): void;
    (
        e: "saved",
        payload: {
            createdMaterialSampleSet: SavedMaterialSampleSet | null;
            createdRequest: Request | null;
        }
    ): void;
}>();

const materialSamplesContext = ref<MaterialSamplesContext>({
    experimentCode: props.experiment.code,
    collectionSOP: null,
    needByDate: null,
    samplesPerSource: null,
    materialType: null,
    descriptors: [],
    things: [],
});
const materialSamplesValid = ref(false);

const request = ref<Request>({
    experimentCode: props.experiment.code,
    status: RequestStatus.DRAFT,
    needByDate: null,
    requestedByEmail: "",
    sourceSampleSet: null,
    protocol: null,
    processor: null,
    requestContainerType: null,
    samplesContainerType: null,
});

const requestValid = ref(false);
const samplesChildForm = ref<MaterialSamplesFormInstance | null>(null);
const requestChildForm = ref<RequestFormInstance | null>(null);
const createdMaterialSampleSet = ref<SavedMaterialSampleSet | null>(null);
const createdRequest = ref<Request | null>(null);

const isAllValid = computed(() => {
    return materialSamplesValid.value && requestValid.value;
});

async function configure() {
    withLoadingScreen(async () => {
        createdMaterialSampleSet.value = await samplesChildForm.value!.saveSampleSet();
        request.value.sourceSampleSet = createdMaterialSampleSet.value;
        createdRequest.value = await requestChildForm.value!.saveRequest();
        console.log("createdRequest", createdRequest.value);

        emit("saved", {
            createdMaterialSampleSet: createdMaterialSampleSet.value,
            createdRequest: createdRequest.value,
        });
    });
}

function cancel() {
    emit("canceled");
}
</script>
